import { render, staticRenderFns } from "./vrMask.vue?vue&type=template&id=543b8f22&scoped=true&"
import script from "./vrMask.vue?vue&type=script&lang=js&"
export * from "./vrMask.vue?vue&type=script&lang=js&"
import style0 from "./vrMask.vue?vue&type=style&index=0&id=543b8f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b8f22",
  null
  
)

export default component.exports